import React, { useCallback, useState, useMemo } from "react";
import { toast } from "react-toastify";
import {
  ArrowDownTrayIcon,
  PresentationChartBarIcon,
} from "@heroicons/react/24/outline";

import {
  inventorySparesDownloadFailedRequest,
  inventorySparesRescanRequest,
} from "../../../../http-request/inventory/inventoryDownloadFile";

import classes from "./inventorySparesLotListFilterPage.module.css";

export const InventorySparesLotListFilterPage = ({
  inventoryId,
  firstImageExist,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isRescanning, setIsRescanning] = useState(false);

  /**
   * Disable actions when image_exist === 2
   */
  const isActionDisabled = useMemo(
    () => firstImageExist === 2,
    [firstImageExist]
  );

  const handleDownload = useCallback(async () => {
    if (!inventoryId) return toast.error("Invalid inventory ID");
    if (isActionDisabled) return;

    try {
      setIsDownloading(true);

      const fileData = await inventorySparesDownloadFailedRequest({
        category: "spares",
        requestId: inventoryId,
      });

      const blob = new Blob([fileData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `mobiGarage_${inventoryId}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Download completed!");
    } catch (err) {
      console.error(err);
      toast.error("Error while downloading");
    } finally {
      setIsDownloading(false);
    }
  }, [inventoryId, isActionDisabled]);

  const handleRescan = useCallback(async () => {
    if (!inventoryId) return toast.error("Invalid inventory ID");
    if (isActionDisabled) return;

    try {
      setIsRescanning(true);

      await inventorySparesRescanRequest({
        category: "spares",
        requestId: inventoryId,
      });

      toast.success("Rescan completed!");
    } catch (err) {
      console.error(err);
      toast.error("Error while rescanning");
    } finally {
      setIsRescanning(false);
    }
  }, [inventoryId, isActionDisabled]);

  return (
    <div className={classes.box}>
      <div className={classes.box__content}>
        <button
          className={classes.box__btn}
          onClick={handleRescan}
          disabled={isRescanning || isActionDisabled}
          title={isActionDisabled ? "No valid images found" : ""}
        >
          <PresentationChartBarIcon className={classes.icon} />
          {isRescanning ? "Rescanning..." : "Rescan"}
        </button>

        <button
          className={classes.box__btn}
          onClick={handleDownload}
          disabled={isDownloading || isActionDisabled}
          title={isActionDisabled ? "No invalid images available" : ""}
        >
          <ArrowDownTrayIcon className={classes.icon} />
          {isDownloading ? "Downloading..." : "Download Invalid Images"}
        </button>
      </div>
    </div>
  );
};
